import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Menu', href: '#menu' },
    { label: 'Info', href: '#info' },
    { label: 'Access', href: '#access' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm  py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2 group">
          <span className="font-script  text-2xl md:text-3xl font-bold text-foreground-950">
            Trattoria <span className="italic font-script text-primary-400">Sole</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-l font-heading  tracking-wide whitespace-nowrap text-foreground-950 hover:text-foreground-950 transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className="whitespace-nowrap px-6 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold tracking-wide hover:bg-primary-600 transition-all duration-300 hover:scale-105"
          >
            ご予約
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="メニューを開く"
        >
          <i className={`z-50 text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      <div
        className={`absolute top-0 left-0 w-full md:hidden overflow-hidden transition-all duration-400 ${
          mobileOpen
            ? 'absolute top-0 left-0 w-full h-dvh py-32'
            : 'max-h-0'
        } bg-background-50/95 backdrop-blur-sm`}
      >
        <div className="flex flex-col items-center gap-9 px-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="text-sm font-heading tracking-wide whitespace-nowrap text-foreground-300"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            className="whitespace-nowrap px-10 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold tracking-wide"
          >
            ご予約
          </a>
        </div>
      </div>
    </nav>
  );
}